import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

export function validateLegacyQuoteFile(file: File): string | null {
  const name = file.name.toLowerCase();
  const isPdf = file.type === 'application/pdf' || name.endsWith('.pdf');
  if (!isPdf) return 'Quote file must be a PDF.';
  if (file.size > 25 * 1024 * 1024) return 'PDF must be under 25 MB.';
  return null;
}

export async function uploadLegacyQuoteFile(
  orgId: string,
  packageId: string,
  file: File,
): Promise<{ storagePath: string; downloadUrl: string }> {
  const storagePath = `supplier-rfq-quotes/${orgId}/${packageId}/${Date.now()}_${file.name.replace(/[^\w.\-]+/g, '_')}`;
  const storageRef = ref(storage, storagePath);
  await uploadBytes(storageRef, file, {
    contentType: file.type || 'application/pdf',
  });
  const downloadUrl = await getDownloadURL(storageRef);
  return { storagePath, downloadUrl };
}
